import API from '@/models/API';
import moment from 'moment';

export let sleepUntil = (boolFn = () => false, limit = 3000) => {
  let start = new Date();
  const loop = (done) =>
    boolFn() || new Date() - start > limit ? done() : setTimeout(() => loop(done), 500);
  return new Promise(loop);
};

export let getBase64ImageFromUrl = async (imageUrl) => {
  try {
    let response = await API.post(
      `/companies/${localStorage.getItem('storeId')}/campaigns/image-to-b64`,
      { url: imageUrl }
    );

    let base64 = response.data.data.b64;
    return base64;
  } catch (error) {
    console.error('Error fetching or converting the image:', error);
    throw error;
  }
};

export const onlyIntegerNumbers = (event) => {
  const key = event.key;
  if (!/^\d+$/.test(key)) {
    event.preventDefault();
  }
};

export let localizeDate = (date, short) => {
  return date
    ? new Date(date).toLocaleString(this.locale, {
        weekday: short ? undefined : 'long',
        year: 'numeric',
        month: short ? 'numeric' : 'long',
        day: 'numeric',
      })
    : '-';
};

const SINGLE_DATE_BILLING_TYPES = ['credit', 'product'];
const BILLING_DATE_FORMAT = 'DD/MM/YYYY';
const BILLING_DATETIME_FORMAT = 'DD/MM/YYYY HH:mm:ss';

export const isSingleDateBilling = (billing) =>
  SINGLE_DATE_BILLING_TYPES.includes((billing?.type || '').toLowerCase());

export const formatBillingDate = (dateValue, dateFormat = BILLING_DATE_FORMAT) => {
  if (!dateValue) return '-';
  return moment(dateValue).format(dateFormat);
};

export const formatBillingDateTime = (dateValue, dateTimeFormat = BILLING_DATETIME_FORMAT) => {
  if (!dateValue) return '-';
  return moment(dateValue).format(dateTimeFormat);
};

const getFallbackBillingDate = (billing) => {
  const type = (billing?.type || '').toLowerCase();
  if (type && type !== 'subscription' && billing?.payment_due) {
    return billing.payment_due;
  }
  return null;
};

export const formatBillingPeriodValue = (billing, dateFormat = 'DD/MM/YYYY') => {
  if (!billing?.period?.from) {
    const fallbackDate = getFallbackBillingDate(billing);
    return fallbackDate ? formatBillingDate(fallbackDate, dateFormat) : '-';
  }

  const from = formatBillingDate(billing.period.from, dateFormat);

  if (isSingleDateBilling(billing)) {
    return from;
  }

  const to = formatBillingDate(billing.period.to || billing.period.from, dateFormat);
  return `${from} - ${to}`;
};

export const getBillingPeriodDisplay = (billing, locale = 'en-US') => {
  const period = billing?.period;

  if (!period?.from) {
    const fallbackDate = getFallbackBillingDate(billing);
    if (fallbackDate) {
      return formatBillingDate(fallbackDate);
    }
  }

  if (!period?.from && billing?.periodVal) {
    return isSingleDateBilling(billing)
      ? billing.periodVal.split(' - ')[0] || billing.periodVal
      : billing.periodVal;
  }

  if (!period?.from) return '-';

  const fromDate = formatBillingDate(period.from);

  if (isSingleDateBilling(billing)) {
    return fromDate;
  }

  const toDate = formatBillingDate(period.to || period.from);
  return `${fromDate} - ${toDate}`;
};
